import { render, staticRenderFns } from "./ingredients-window.vue?vue&type=template&id=0cf9c5b6&scoped=true&"
import script from "./ingredients-window.vue?vue&type=script&lang=js&"
export * from "./ingredients-window.vue?vue&type=script&lang=js&"
import style0 from "./ingredients-window.vue?vue&type=style&index=0&id=0cf9c5b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9c5b6",
  null
  
)

export default component.exports